module.exports = __webpack_public_path__ + "static/ADOLESCENT-3fa0ce868c6a207935cf5501abf28dfd.png";